import { render, staticRenderFns } from "./HeroBlock.vue?vue&type=template&id=b88abd04&scoped=true&"
import script from "./HeroBlock.vue?vue&type=script&lang=ts&"
export * from "./HeroBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeroBlock.vue?vue&type=style&index=0&id=b88abd04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88abd04",
  null
  
)

export default component.exports